:host(c-main) {
  /**
   * @prop --c-main-background-color: Background color
   * @prop --c-main-text-color: Text color
   */
  --_c-main-background-color: var(--c-main-background-color, var(--c-primary-200));
  --_c-main-text-color: var(--c-main-text-color, var(--c-text-body));

  background: var(--_c-main-background-color);
  color: var(--_c-main-text-color);
  display: flex;
  flex-direction: column;
  height: 100vh;

  ::slotted(*) {
    color: var(--_c-main-text-color);
  }

  main.dashboard {
    display: grid;
    grid-template: "toolbar toolbar" auto "sidenav page" 1fr / auto 1fr;
    gap: 0;
    
    ::slotted(c-toolbar) {
      grid-area: toolbar;
    }
    
    ::slotted(c-page) {
      grid-area: page;
    }
    
    ::slotted(c-side-navigation) {
      grid-area: sidenav;
    }
  }
}

*,
::after,
::before,
body {
  box-sizing: border-box;
  margin: 0;
}
